import type { RentalManagerAuthCheckUserInfoWebApiDto } from '@zg-rentals/ts-rental-manager-api-client';
import React from 'react';
import { RentalManagerEnvironmentContext } from '../components/RentalManagerEnvironmentProvider';

export const useRentalManagerUser = () => {
  const { environment, setEnvironment } = React.useContext(RentalManagerEnvironmentContext);
  const user = React.useMemo(() => {
    return environment.user;
  }, [environment.user]);

  const updateUser = (newUser: RentalManagerAuthCheckUserInfoWebApiDto) => {
    setEnvironment({
      ...environment,
      user: newUser,
      initialAuthComplete: true,
    });
  };

  return { user, updateUser };
};
